import { getRecipesIngredients } from '../../../../communication/recipes';
import { entitiesMap, getFullActionName } from '../../../reusable-reducers/entities-map';

export const getRecipesIngredientsAction = () => async (dispatch) => {
    dispatch(getRecipesIngredientsStartAction());

    try {
        const res = await getRecipesIngredients();

        if (res.status === 200) {
            dispatch(getRecipesIngredientsSuccessAction(res.data.items));
        }
    } catch (error) {
        dispatch(getRecipesIngredientsErrorAction(error));
    }
};

const getRecipesIngredientsStartAction = () => ({
    type: getFullActionName(
        entitiesMap.recipes.ingredients.baseName,
        entitiesMap.recipes.ingredients.methodName.get,
        entitiesMap.recipes.ingredients.allowedActions.start
    ),
});

const getRecipesIngredientsSuccessAction = (data) => ({
    type: getFullActionName(
        entitiesMap.recipes.ingredients.baseName,
        entitiesMap.recipes.ingredients.methodName.get,
        entitiesMap.recipes.ingredients.allowedActions.success
    ),
    payload: data,
});

const getRecipesIngredientsErrorAction = (error) => ({
    type: getFullActionName(
        entitiesMap.recipes.ingredients.baseName,
        entitiesMap.recipes.ingredients.methodName.get,
        entitiesMap.recipes.ingredients.allowedActions.error
    ),
    payload: error,
});
